// Example usage: <div v-sanitize-html="htmlString"></div>
// Similar to <div v-html></div>

// Vue imports
import {Directive, DirectiveBinding} from 'vue';

// 3rd Party Imports
import DOMPurify from 'dompurify';

// Sanitize HTML strings using DOMPurify
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html);
};

// Create a directive to sanitize HTML from potentially unsafe sources
// both at initial render and when the value changes
export const sanitizeHtmlDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
};
